import { observer } from "mobx-react";
import React from "react";
import "./styles.scss";

const DividerVertical: React.FC = () => {
  return <div className="vertical-divider" />;
};

export default observer(DividerVertical);
